import './notyf-DIw0RvBj.js';
import { S as SwiperExt } from './swiper-BAqQR4kf.js';
import { S as Swiper } from './swiper-core-DtIdGk2i.js';
import { N as Navigation } from './navigation-C5BjyN_6.js';
import { A as A11y } from './a11y-Cqda0b-Q.js';
import './create-element-if-not-defined-C23s5IpL.js';

class FeaturedCollectionsAlt extends SwiperExt {
  swiper = this.querySelector('.swiper');
  nextButton = this.querySelector('.swiper-button-next');
  prevButton = this.querySelector('.swiper-button-prev');
  slidesPerViewDesktop = this.swiper.querySelectorAll('.swiper-slide').length === 3 ? 3 : 4;

  connectedCallback() {
    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Navigation],
      slidesPerView: 1,
      spaceBetween: 1,
      lazyPreloadPrevNext: 2,
      loop: true,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: this.slidesPerViewDesktop,
        },
      },
    });
  }
}

customElements.define('featured-collections-alt', FeaturedCollectionsAlt);
